import axios from "axios";
import { auth } from "../../contexts/authentication";

type UserData = {
  uid: string;
  name: string;
  email: string;
  authProvider: string;
  whatsapp: string;
  api_key: string;
  status: string;
  plano_atual: string;
  vencimento: string;
};

const getUser = async () => {  
  const currentUser = auth.currentUser;  
  if (currentUser) {
    const { data } = await axios.get("/get-user", {
      params: { uid: currentUser?.uid }
    });
    return data;
  }
}

export { getUser };
export type { UserData };